import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { EnvironmentAdapter } from 'src/app/adapters/environment/environment.adapter';
import { checkDevEnvironment } from 'src/app/utils/environment/environment.utils';
import { Environment } from 'src/environments/environment.utils';
import { RemoteLoggerUseCase } from '../remote-logger/remote-logger.use-case';
import { FeatureFlags } from './utils/feature-flag.models';
import { logFeatureFlags } from './utils/feature-flag.utils';

//This is jankey, but feature flags can find their way into unconventional situations. We need to be able to access them from anywhere.
let setFeatureFlags = new FeatureFlags();
export const MSFeatureFlags = {
  get(): FeatureFlags {
    return setFeatureFlags;
  }
};

@Injectable({
  providedIn: null
})
export abstract class FeatureFlagsUseCase {
  abstract set(featureFlags: FeatureFlags): Observable<void>;
}

@Injectable({
  providedIn: 'root'
})
export class RealFeatureFlagsUseCase implements FeatureFlagsUseCase {

  constructor(
    private remoteLogger: RemoteLoggerUseCase
  ) {}

  set(featureFlags: FeatureFlags): Observable<void> {
    setFeatureFlags = featureFlags;
    logFeatureFlags(featureFlags, this.remoteLogger);

    return of(undefined);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MockFeatureFlagsUseCase implements FeatureFlagsUseCase {

  constructor(
    private environmentAdapter: EnvironmentAdapter,
    private remoteLogger: RemoteLoggerUseCase
  ) {}

  set(featureFlags: FeatureFlags): Observable<void> {
    const setObservable = this.environmentAdapter
      .getEnvironment()
      .pipe(
        map((environment) => this.mapFeatureFlags(featureFlags, environment)),
        tap(() => logFeatureFlags(setFeatureFlags, this.remoteLogger))
      );

    return setObservable;
  }

  private mapFeatureFlags(featureFlags: FeatureFlags, environment: Environment) {
    if (!checkDevEnvironment(environment)) {
      setFeatureFlags = featureFlags;
      return;
    }

    const featureFlagsAggregate = {
      ...featureFlags,
      ...environment.featureFlags,
    } as FeatureFlags;

    setFeatureFlags = featureFlagsAggregate;
  }
}
